

















import Vue from 'vue'

export default Vue.extend({
  name: 'AdditionalServicesWarningDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    warningText: String,
    month1: String,
    month2: String,
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onSaveMonth1Click (): void {
      this.$emit('save', 1)
    },

    onSaveMonth2Click (): void {
      this.$emit('save', 2)
    }
  },

  mounted (): void {
  }
})
